import { render, staticRenderFns } from "./video_avatar_clone.vue?vue&type=template&id=797485e2"
import script from "./video_avatar_clone.vue?vue&type=script&lang=js"
export * from "./video_avatar_clone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports